import script from "./reason.vue?vue&type=script&lang=ts&setup=true"
export * from "./reason.vue?vue&type=script&lang=ts&setup=true"

import "./reason.vue?vue&type=style&index=0&id=84992f46&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84992f46"]])

export default __exports__